import { useQuery } from '@apollo/client'
import { usuarioLogadoQueryGql } from '../data/usuario-logado'
import type { GetUsuarioLogadoQueryQuery } from '@/core/types/graphql'

export const useUsuarioLogado = () => {
  const { data: { usuarioLogado } = {} } = useQuery<GetUsuarioLogadoQueryQuery>(
    usuarioLogadoQueryGql,
    {
      fetchPolicy: 'cache-first'
    }
  )

  return { usuarioLogado }
}
